export const getRegExpFromString = (input: string, flags?: string): RegExp => {
  // Replace taken from MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
  const escaped = input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  return new RegExp(escaped, flags);
};
